<template>
  <section>
    <ConfirmModal :modalShow="modalUnidade.showModal" :typeModal="modalUnidade.typeModal" itemIdentifier="unidade"
                  :infoText="{warning: modalUnidade.infoText}"
                  @confirmed="confirmInativarIntegracao" @canceled="cancelInativarIntegracao" />

    <b-row>
      <b-col lg="6">
        <b-form-group
            label-for="name_cnes"
            label-class="font_size_label"
            class="search-container px-0"
        >
          <div class="search-input-icon">
            <feather-icon
                icon="SearchIcon"
                size="22"
            />
          </div>
          <b-form-input
              v-model="searchTerm"
              id="unidade_search"
              class="form-control rounded-20"
              placeholder="Buscar Unidade ou o CNES"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-table id="tableUnidade" style="max-height: 400px;" :fields="table.fields" :items="filteredItems" responsive
      :stickyColumn="true" no-local-sorting :no-sort-reset="true" :busy.sync="filtering" show-empty
      @sort-changed="ordemColumn" class="mb-2">

      <template #head(data_inicial)>
        <span>
          Data Inicial
          <feather-icon
              icon="HelpCircleIcon"
              size="14"
              class="ml-1 cursor-pointer "
              v-b-tooltip.hover
              title="Define a partir de qual data os registros serão considerados, com base na data do gesto vacinal."
          />
        </span>
      </template>

      <template #empty>
        <span v-if="filtering">Processando.</span>
        <span v-else>Nenhum registro encontrado.</span>
      </template>

      <template #cell(permite_integracao_rnds)="row">
        <TableSwitch v-if="podeIntegrar(row.item)" :checked="row.item.permite_integracao_rnds"
          :description="`${row.item.id_unidade} - ${row.item.descricao_unidade}`" :itemId="row.item.id_unidade" :disabled="!permiteGerenciar"
           @stateModified="changeAtivarIntegracao($event, row)"
        />

        <TableSwitch v-else :checked="row.item.permite_integracao_rnds" disabled :description="`${row.item.id_unidade} - ${row.item.descricao_unidade}`"
          :itemId="row.item.id_unidade" />
      </template>

      <template #cell(data_inicial)="row">
        <div class="d-flex flex-row align-items-center py-1">
          <b-form-datepicker
              :id="`data-registro-${row.item.id_unidade}`"
              v-model="row.item.data_registro_envio"
              :hide-header="true"
              placeholder="00/00/0000"
              :disabled="!podeIntegrar(row.item) || !permiteGerenciar || !row.item.permite_integracao_rnds"
              right
              label-help="Selecione a data"
              :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
              locale="pt-BR"
              :min="new Date(2025, 0, 1)"
              class="mr-1 comprimento_min_input"
          />

          <feather-icon
              icon="XIcon"
              size="20"
              class="text-muted cursor-pointer"
              @click="row.item.data_registro_envio = null"
              v-if="row.item.data_registro_envio"
              v-b-tooltip.hover
              title="Limpar data"
          />
        </div>

        <div
            class="d-flex align-items-center text-success mt-1"
            v-if="row.item.status == 'Apta' && !row.item.data_registro_envio && row.item.permite_integracao_rnds"
            style="font-size: 0.8rem;"
        >
          <feather-icon icon="CheckCircleIcon" size="12" class="mr-1" />
          <small class="text-success">
            Usando data inicial de registro: {{ formatData(form.dataFiltro) }}
          </small>
        </div>
      </template>

      <template #cell(descricao_unidade)="row">
        <span class="font-weight-bold comprimento_maximo_celulas">
          {{ row.item.descricao_unidade }}
        </span>
      </template>

      <template #cell(status)="row">
        <span :class="podeIntegrar(row.item) ? 'text-success' : 'text-danger'">
          {{ row.item.status }}
        </span>
      </template>

      <template #cell(cnes)="row">
        <span class="text-center" :class="podeIntegrar(row.item) ? 'text-success' : 'text-danger'">
          {{ row.item.cnes || '--' }}
        </span>
      </template>

      <template #cell(data_ativacao)="row">
        <span class="text-center">
          {{ formatDataHora(row.item.data_ativacao) || '--' }}
        </span>
      </template>

    </b-table>
  </section>
</template>

<script>
import CustomPagination from "@/views/components/custom/pagination/CustomPagination.vue";
import TableSwitch from "@/views/components/custom/table-switch/TableSwitch.vue";
import {
  BCol,
  BFormDatepicker,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BTable,
  BFormSelect,
  BFormGroup,
  BRow
} from "bootstrap-vue";
import vSelect from 'vue-select'
import moment from "moment";
import ConfirmModal from '@/views/components/custom/modals/ConfirmModal.vue';

export default {
  components: {
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    BFormDatepicker, BTable, BCol, TableSwitch, CustomPagination, vSelect, BFormSelect, BRow,
    ConfirmModal
  },
  props: {
    form: {
      required: true,
      type: Object,
    },
    permiteGerenciar: {
      required: true,
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      table: {
        fields: [
          { key: 'permite_integracao_rnds', sortable: false, label: 'Ativar integração', visible: true, class: 'comprimento_status'},
          { key: 'descricao_unidade', sortable: false, label: 'Unidade Operacional', visible: true, class: 'comprimento_min' },
          { key: 'cnes', sortable: false, label: 'CNES', visible: true },
          { key: 'data_inicial', sortable: false, label: '', visible: true, class: 'comprimento_min' },
          { key: 'data_ativacao', sortable: false, label: 'Data de Ativação', visible: true },
          { key: 'status', sortable: false, label: 'Status', visible: true, class: 'comprimento_status' },
        ],
        items: [],
      },
      modalUnidade: {
        showModal: false,
        typeModal: '',
        infoText: ''
      },
      filtering: false,
      paginationData: null,
      indexItemDesativar: null,
      searchTerm: '',
    }
  },
  computed: {
    filteredItems() {
      if (!this.searchTerm) return this.table.items;

      const term = this.searchTerm.toLowerCase();

      return this.table.items.filter(item => {
        const unidade = item.descricao_unidade?.toLowerCase() || '';
        const cnes = String(item.cnes || '').toLowerCase();
        return unidade.includes(term) || cnes.includes(term);
      });
    }
  },
  mounted() {
    this.getDadosUnidades();
  },
  methods: {
    getDadosUnidades() {
      this.table.items = this.form.unidades;

      this.paginationData = {
        currentPage: 1,
        totalLines: 1,
        fromLine: 1,
        toLine: 1,
        defaultSize: 1
      };
    },
    ordemColumn({ sortBy, sortDesc }) {
      const dados = {
        columnOrder: sortBy,
        order: sortDesc ? 'desc' : 'asc',
      }
      this.$emit('sortTable', dados);
    },
    podeIntegrar(unidade) {
      return unidade.status === 'Apta';
    },
    updateCurrentPage(page) {
      this.paginationData.currentPage = page;
      this.filtering = true;
      this.filter = !this.filter;
      this.$emit('updatePagination', this.paginationData);
    },
    formatData(data) {
      return data ? moment(data).format('DD/MM/YYYY') : '--'
    },
    formatDataHora(data) {
      return data ? moment(data).format('DD/MM/YYYY HH:mm') : '--'
    },
    changeAtivarIntegracao(event, row) {
      const idx = row.index;
      this.indexItemDesativar = idx;

      this.table.items[idx].permite_integracao_rnds = event.state;

      if (event.state) {
        this.$set(this.table.items[idx], 'data_ativacao', moment().format('YYYY-MM-DD HH:mm:ss-03:00'));
        this.$set(this.table.items[idx], 'tipo_data', 'data_atendimento_vacinacao');
      } else {
        this.modalUnidade.typeModal = 'warning';
        this.modalUnidade.infoText = `A integração para a unidade ${this.table.items[idx].descricao_unidade} será desativada.`;
        this.modalUnidade.showModal = true;
      }

      this.$emit('update-unidades', this.table.items);
    }
    ,
    confirmInativarIntegracao() {
      const idx = this.indexItemDesativar;

      this.modalUnidade.showModal = false;
      this.modalUnidade.infoText = '';
      this.table.items[idx].permite_integracao_rnds = false;
      this.table.items[idx].data_ativacao = null;

      this.$emit('update-unidades', this.table.items);
    },
    cancelInativarIntegracao() {
      this.table.items[this.indexItemDesativar].permite_integracao_rnds = true;
      this.modalUnidade.showModal = false;
      this.modalUnidade.infoText = '';
    }
  },
  watch: {
    'table.items': {
      handler(newItems) {
        this.$emit('update-unidades', newItems);
      },
      deep: true
    }
  }

}
</script>
<style>
  .search-container {
    position: relative;
  }

  .search-input-icon {
    position: absolute;
    top: 20%;
    right: 10px;
    cursor: pointer;
    color: #b6b2b5;
    font-weight: bold;
  }

  .rounded-20 {
    border-radius: 20px !important;
  }

  .comprimento_status{
    width: 50px;
  }

  .comprimento_min{
    min-width: 200px;
  }

  .comprimento_min_input{
    min-width: 150px;
  }
</style>
